// https://juejin.cn/post/7143877447446954021
import cn from './cn.json'
import en from './en.json'

export default {
  cn,
  en,
}